// client/src/utils/env.js
// CRA-safe env helper: use ONLY static process.env references.

const isProd = process.env.NODE_ENV === "production";

// --- API base ---
const API_BASE_DEV = process.env.REACT_APP_API_BASE_DEV; // http://localhost:3001
const API_BASE_PROD = process.env.REACT_APP_API_BASE_PROD; // https://api.jamcanhotpeppersauce.com
const API_BASE_UNIFIED = process.env.REACT_APP_API_BASE; // optional single-var fallback

export const API_BASE =
  (isProd
    ? API_BASE_PROD || API_BASE_UNIFIED
    : API_BASE_DEV || API_BASE_UNIFIED) || "";

// --- Stripe publishable key ---
const STRIPE_PK_DEV = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_DEV;
const STRIPE_PK_PROD = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_PROD;
const STRIPE_PK_UNIFIED = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

export const STRIPE_PUBLISHABLE_KEY =
  (isProd
    ? STRIPE_PK_PROD || STRIPE_PK_UNIFIED
    : STRIPE_PK_DEV || STRIPE_PK_UNIFIED) || "";

export const isProduction = isProd;

// Helpful warnings in dev only
if (!isProd) {
  if (!API_BASE)
    console.warn(
      "[env] API_BASE is empty. Set REACT_APP_API_BASE_DEV or REACT_APP_API_BASE."
    );
  if (!STRIPE_PUBLISHABLE_KEY)
    console.warn(
      "[env] STRIPE_PUBLISHABLE_KEY is empty. Set REACT_APP_STRIPE_PUBLISHABLE_KEY_DEV or unified."
    );
}
